
export enum Province {
  GAUTENG = "Gauteng",
  WESTERN_CAPE = "Western Cape",
  KWAZULU_NATAL = "KwaZulu-Natal",
  EASTERN_CAPE = "Eastern Cape",
  FREE_STATE = "Free State",
  LIMPOPO = "Limpopo",
  MPUMALANGA = "Mpumalanga",
  NORTH_WEST = "North West",
  NORTHERN_CAPE = "Northern Cape"
}

export enum Industry {
  CONSTRUCTION = "Construction",
  HOSPITALITY = "Hospitality",
  RETAIL = "Retail",
  MANUFACTURING = "Manufacturing",
  LEGAL = "Legal",
  TECH = "Technology",
  AGRICULTURE = "Agriculture",
  REAL_ESTATE = "Real Estate",
  AUTOMOTIVE = "Automotive",
  BEAUTY_WELLNESS = "Beauty & Wellness",
  LOGISTICS = "Logistics",
  EVENTS_ENTERTAINMENT = "Events & Entertainment",
  EDUCATION = "Education & Training",
  FMCG = "FMCG / Wholesale",
  SECURITY = "Security Services",
  MEDICAL_HEALTH = "Medical & Health",
  PROFESSIONAL_SERVICES = "Professional Services"
}

export enum CompanySize {
  MICRO = "Micro (1-10 employees)",
  SMALL = "Small (11-50 employees)",
  MEDIUM = "Medium (51-200 employees)",
  LARGE = "Large (201-500 employees)",
  ENTERPRISE = "Enterprise (501+ employees)"
}

export interface ActivityNote {
  id: string;
  date: string;
  text: string;
}

export interface VettingCategory {
  category: string;
  score: number;
  reason: string;
}

export interface VerifiedSource {
  title: string;
  uri: string;
}

export interface Lead {
  id: string;
  dateScraped: string;
  businessName: string;
  industry: Industry;
  province: Province;
  companySize?: string;
  website: string;
  contactNumber: string;
  email: string;
  linkedInUrl?: string;
  instagramUrl?: string;
  facebookUrl?: string;
  lastSocialActivityDate?: string;
  socialActivitySummary?: string;
  instagramAudit?: {
    followerCount?: string;
    isVisualHeavy: boolean;
    postFrequency: 'Daily' | 'Weekly' | 'Monthly' | 'Stale';
    hasBioLink: boolean;
  };
  facebookAudit?: {
    lastPostDate?: string;
    engagementLevel: 'High' | 'Medium' | 'Low' | 'None';
    hasReviews: boolean;
    isOptimized: boolean; // Cover photo, info filled, etc.
  };
  linkedInAudit?: {
    profileCompleteness: 'High' | 'Medium' | 'Low';
    estimatedEmployeeCount?: string;
    recentActivity: boolean;
  };
  vettingScore: number;
  vettingBreakdown?: VettingCategory[];
  status: 'Vetted' | 'Processing' | 'Discarded';
  notes: string;
  isCatchOfTheDay: boolean;
  isArchived: boolean;
  activityLog: ActivityNote[];
  validationStatus?: 'Correct' | 'Incorrect' | 'Unverified';
  validationFeedback?: string;
  verifiedSources?: VerifiedSource[];
}

export interface AgentStats {
  leadsFound: number;
  totalVetted: number;
  discarded: number;
  uptimeHours: number;
}
